import type { FeatureFlagDefinitionShape } from "../types";
import { featureflagsProspectOverviewProperties } from "./flags/featureflags.prospect_overview";
import { featureflagsLinkProperties } from "./flags/featureflags_link";
import { featureflagsProductAnnouncementBannerProperties } from "./flags/product_announcement_banner";

/**
 * This serves as a base for mocking feature flags and also as the base for the default value for the context (defined in context.ts)
 *
 * In order to link code owners, each set of properties is defined in its own directory under `flags/` and then imported here.
 * IMPORTANT: websdk-stub.js in `dashboard/.storybook/websdk-stub.js` uses this to simulate the behavior of default feature flag values.
 * The featureFlagStorybookEnhancer can be used to override this value
 */
export const defaultFeatureFlagProperties = getFeatureFlagDefinitions({
  "featureflags.prospect_overview": featureflagsProspectOverviewProperties,
  featureflags_link: featureflagsLinkProperties,
  "floating-connect-with-sales-button": {},
  offerfit_landing_page_cta: {},
  product_announcement_banner: featureflagsProductAnnouncementBannerProperties,
  chameleon_sdk: {},
});

function getFeatureFlagDefinitions<T extends FeatureFlagDefinitionShape>(map: T): T {
  return map;
}
